export default "__VITE_ASSET__Yqnr9o0y__"